import iso from "iso-3166-1";
import * as Yup from "yup";
import { ERROR_CODES } from "../util";

const countryList = iso.all().map((country) => country.alpha2);

export const dynamicIsRequiredTest = (isRequired) => {
	return {
		name: "dynamicIsRequiredTest",
		test: (value) => {
			return isRequired ? Boolean(value) : true;
		},
		message: ERROR_CODES.REQUIRED
	};
};

export const billingInfoFieldSchema = {
	name: (isRequired) =>
		Yup.string()
			.max(35, ERROR_CODES.MAX_LENGTH_EXCEEDED)
			.test(dynamicIsRequiredTest(isRequired))
			.typeError(ERROR_CODES.INVALID),
	addressLine1: (isRequired) =>
		Yup.string()
			.max(35, ERROR_CODES.MAX_LENGTH_EXCEEDED)
			.test(dynamicIsRequiredTest(isRequired))
			.typeError(ERROR_CODES.INVALID),
	addressLine2: () => Yup.string().max(35, ERROR_CODES.MAX_LENGTH_EXCEEDED).typeError(ERROR_CODES.INVALID),
	city: (isRequired) =>
		Yup.string()
			.max(30, ERROR_CODES.MAX_LENGTH_EXCEEDED)
			.test(dynamicIsRequiredTest(isRequired))
			.typeError(ERROR_CODES.INVALID),
	state: (isRequired) =>
		Yup.string()
			.max(30, ERROR_CODES.MAX_LENGTH_EXCEEDED)
			.test(dynamicIsRequiredTest(isRequired))
			.typeError(ERROR_CODES.INVALID),
	postalCode: (isRequired) =>
		Yup.string().max(10, ERROR_CODES.MAX_LENGTH_EXCEEDED).test(dynamicIsRequiredTest(isRequired)),
	country: (isRequired) =>
		Yup.string()
			.oneOf([...countryList], ERROR_CODES.INVALID)
			.test(dynamicIsRequiredTest(isRequired))
			.typeError(ERROR_CODES.INVALID),
	emailAddress: (isRequired) =>
		Yup.string()
			.email(ERROR_CODES.INVALID)
			.max(35, ERROR_CODES.MAX_LENGTH_EXCEEDED)
			.test(dynamicIsRequiredTest(isRequired))
			.typeError(ERROR_CODES.INVALID),
	phoneNumber: (isRequired) =>
		Yup.string()
			.test(dynamicIsRequiredTest(isRequired))
			.max(35, ERROR_CODES.MAX_LENGTH_EXCEEDED)
			.typeError(ERROR_CODES.INVALID)
};

/**
 * For validating a user's entered information.
 * @param {string[]} billingInfoKeys
 * @return {Readonly<ObjectSchema>}
 */
export const buildBillingInfoSchema = (billingInfoKeys) => {
	return Yup.object().shape({
		name: billingInfoFieldSchema.name(billingInfoKeys.includes("name")),
		addressLine1: billingInfoFieldSchema.addressLine1(billingInfoKeys.includes("addressLine1")),
		addressLine2: billingInfoFieldSchema.addressLine2(),
		city: billingInfoFieldSchema.city(billingInfoKeys.includes("city")),
		state: billingInfoFieldSchema.state(billingInfoKeys.includes("state")),
		postalCode: billingInfoFieldSchema.postalCode(billingInfoKeys.includes("postalCode")),
		country: billingInfoFieldSchema.country(billingInfoKeys.includes("country")),
		emailAddress: billingInfoFieldSchema.emailAddress(billingInfoKeys.includes("emailAddress")),
		phoneNumber: billingInfoFieldSchema.phoneNumber(billingInfoKeys.includes("phoneNumber"))
	});
};
